import React, { ChangeEventHandler, forwardRef, useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowQuestionnaireFieldItem } from 'src/interfaces/reservation_flow';
import { useDataAttributeProps } from 'src/hooks/useDataAttributeProps';
import { RSBorderedList } from 'src/reservation-page/bordered-list/RSBorderedList';
import { RSBorderedListItemCheckRadio } from 'src/reservation-page/bordered-list/RSBorderedListItemCheckRadio';

export interface QuestionnaireInputRadioProps {
  [key: `data-${string}`]: string | undefined;
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  item: ReservationFlowQuestionnaireFieldItem;
}

export const QuestionnaireInputRadio = forwardRef<
  HTMLDivElement,
  QuestionnaireInputRadioProps
>((props, ref) => {
  const dataAttributes = useDataAttributeProps(props);
  const { value, onChange, onBlur, item } = props;

  const intl = useIntl();

  const onInputChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      onChange(event.target.value);
      onBlur();
    },
    [onChange, onBlur],
  );

  return (
    <div ref={ref}>
      <div className="mb-1.5">
        <div className="rs-font text-16 text-gray-1000 pc:text-15 whitespace-pre-wrap font-normal">
          {item.label}
          {item.is_required && (
            <span className="text-red-700">
              {intl.formatMessage({
                defaultMessage: '（必須）',
                id: 'Hb4cGG',
                description:
                  'src/templates/merchants/resources/book/components/questionnaire/QuestionnaireInputRadio/index.tsx',
              })}
            </span>
          )}
        </div>
      </div>
      <div>
        <RSBorderedList>
          {item.options &&
            item.options.map((option) => {
              return (
                <RSBorderedListItemCheckRadio
                  {...dataAttributes}
                  key={`questionnaire_${item.id}_${option}`}
                  leftContent={
                    <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
                      {option}
                    </div>
                  }
                  value={option}
                  name={`questionnaire_${item.id}`}
                  checked={
                    typeof value !== 'undefined' ? value === option : false
                  }
                  onChange={onInputChange}
                />
              );
            })}
        </RSBorderedList>
      </div>
    </div>
  );
});

QuestionnaireInputRadio.displayName = 'QuestionnaireInputRadio';
